import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import {
  RemoteServiceDiagnosisQueryParams,
  RemoteServiceDiagnosisResponse,
  RemoteServiceFeatures,
  RemoteServiceQueryParams,
  RemoteServiceRecommendations,
  RemoteServiceSetThresholdQueryParams,
} from './remote-service.model';
import {
  GenericDataResponse,
  HemsFeaturesPresentSincePayload,
  HemsFeaturesPresentSinceResponse,
} from '../analytics/analytics.model';
import { RemoteServiceApiModel } from './remote-service.api-model';

@Injectable()
export class RemoteServiceApi implements RemoteServiceApiModel {
  constructor(private clientService: ClientService) {}

  /**
   * Returns available chart features.
   */
  getFeatures(
    featuresParams: RemoteServiceQueryParams
  ): Observable<{ data: RemoteServiceFeatures }> {
    const endpoint = `iot/v1/analytics-api/dataLake/remoteservice/v0/device_features`;

    return this.clientService.post(endpoint, featuresParams);
  }

  /**
   * Returns diagnosis data.
   */
  getDiagnosis(
    params: RemoteServiceDiagnosisQueryParams
  ): Observable<RemoteServiceDiagnosisResponse> {
    const endpoint = `iot/v1/analytics-api/dataLake/remoteservice/v0/diagnosis`;

    return this.clientService.post(endpoint, params);
  }
  /**
   * Returns diagnosis data.
   */
  saveThreshold(params: RemoteServiceSetThresholdQueryParams): Observable<any> {
    const endpoint = `iot/v1/analytics-api/dataLake/remoteservice/v0/set_device_configuration`;

    return this.clientService.post(endpoint, params);
  }

  /**
   * Returns recommendations data.
   */
  getRecommendations(
    boilerSerials: string[]
  ): Observable<{ data: RemoteServiceRecommendations[] }> {
    const endpoint = `iot/v1/analytics-api/dataLake/remoteservice/v0/recommendations`;

    return this.clientService.post(endpoint, { boiler_ids: boilerSerials });
  }

  /** https://documentation.viessmann-climatesolutions.com/hems-analyticsapi-mw-iot/v1#hems-analyticsapi-mw-iot_Hems_timeseries */
  getDeviceAvailableHemsProperties(
    body: HemsFeaturesPresentSincePayload
  ): Observable<GenericDataResponse<HemsFeaturesPresentSinceResponse>> {
    const endpoint = `iot/v1/analytics-api/dataLake/hems/v0/property_since`;

    return this.clientService.post(endpoint, body);
  }
}
